import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import './index.external.css';

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var styles = {"buttonTile":"buttonTile-35QOn"};

var _excluded = ["children", "className", "eventAttribute", "handleKeyDown", "index", "isDisabled", "isSelected", "onChangeSelection", "selectedIndex"];
var ButtonTile = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      children,
      className,
      eventAttribute,
      handleKeyDown,
      index,
      isDisabled,
      isSelected,
      onChangeSelection,
      selectedIndex
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var eventAttributeList = eventAttribute.split(' ');
  var eventHandlers = eventAttributeList.reduce((accumulator, attribute) => {
    accumulator[attribute] = onChangeSelection ? () => {
      return onChangeSelection(index);
    } : null;
    return accumulator;
  }, {});
  var getRovingTabIndex = () => isSelected || selectedIndex === -1 && index === 0 ? 0 : -1;
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "button-tile",
    "aria-checked": isSelected,
    className: cs(styles.buttonTile, {
      [className]: className
    }),
    onKeyDown: e => handleKeyDown(e, index),
    ref: ref,
    role: "radio",
    tabIndex: getRovingTabIndex()
  }, eventHandlers, otherProps), React.Children.map(children, child => {
    var conditionalProps = {};
    if (child.props.isSelected !== undefined) {
      conditionalProps.isSelected = isSelected;
    }
    if (child.props.isDisabled !== undefined) {
      conditionalProps.isDisabled = isDisabled;
    }
    return child ? /*#__PURE__*/React.cloneElement(child, _objectSpread2({}, conditionalProps)) : null;
  }));
});
var propTypes = {
  /** Children to be rendered within the radio button */
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /** See ButtonTileGroup */
  eventAttribute: PropTypes.string,
  /** Handler for keyboard navigation, generated in ButtonTileGroup component */
  handleKeyDown: PropTypes.func,
  /** See ButtonTileGroup */
  index: PropTypes.number,
  /** Whether to display children in a visually disabled state (note: it can still be selected) */
  isDisabled: PropTypes.bool,
  /** Whether to render in a selected state, generated in ButtonTileGroup component */
  isSelected: PropTypes.bool,
  /** See ButtonTileGroup */
  onChangeSelection: PropTypes.func,
  /** See ButtonTileGroup */
  selectedIndex: PropTypes.number
};
var defaultProps = {
  className: '',
  eventAttribute: 'onClick',
  handleKeyDown: () => {},
  index: -1,
  isDisabled: false,
  isSelected: false,
  onChangeSelection: () => {},
  selectedIndex: -1
};
ButtonTile.propTypes = propTypes;
ButtonTile.defaultProps = defaultProps;

export { ButtonTile, defaultProps, propTypes };
//# sourceMappingURL=index.js.map
